import { render, staticRenderFns } from "./OrganisationDetailNew.vue?vue&type=template&id=c4a3461a&"
import script from "./OrganisationDetailNew.vue?vue&type=script&lang=js&"
export * from "./OrganisationDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationDetailNew.vue?vue&type=style&index=0&id=c4a3461a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports